/**
 * Companies Datatable Field Configurations
 * 
 * Defines all available field metadata for the companies datatable including display names,
 * CSS classes, and data types. Used for filtering, sorting, and column visibility management.
 * Each field object contains actualName (database field), displayName (UI label), cName (CSS class),
 * and type (text, boolean, date, etc).
 */
export const allCompaniesFields = [
  {
    actualName: "tradeName",
    displayName: "Name",
    cName: "",
    type: "text",
  },
  {
    actualName: "entityType",
    displayName: "Entity type",
    cName: "detailmediumdata",
    type: "text",
  },
  {
    actualName: "isActive",
    displayName: "Operational status",
    cName: "detailmediumdata",
    type: "boolean",
  },
  {
    actualName: "slug",
    displayName: "Files",
    cName: "detailmediumdata",
    type: "text",
  },
  {
    actualName: "stageOfDevelopment",
    displayName: "Stage of development",
    cName: "detailmldata",
    type: "text",
  },
  {
    actualName: "description",
    displayName: "Description",
    cName: "detaillongdata",
    type: "text",
  },
  {
    actualName: "reasonsForFailure",
    displayName: "Reasons for shutdown",
    cName: "detaillongdata",
    type: "text",
  },
  {
    actualName: "industry",
    displayName: "Industry",
    cName: "detailmldata",
    type: "text",
  },
  {
    actualName: "categories",
    displayName: "Categories",
    cName: "detailmldata",
    type: "text",
  },
  {
    actualName: "location",
    displayName: "Location",
    cName: "detailmediumdata",
    type: "text",
  },
  {
    actualName: "ownership",
    displayName: "Ownership status",
    cName: "detailmediumdata",
    type: "text",
  },
  {
    actualName: "defensibilityMoat",
    displayName: "Defensibility moats",
    cName: "detailmldata",
    type: "text",
  },
  {
    actualName: "lastFinancingRound",
    displayName: "Last financing round",
    cName: "detailmldata",
    type: "text",
  },
  {
    actualName: "totalInvestment",
    displayName: "Total raised",
    cName: "detailmediumdata",
    type: "quantity",
  },
  {
    actualName: "postMoneyValuation",
    displayName: "Post-money valuation",
    cName: "detailmediumdata",
    type: "quantity",
  },
  {
    actualName: "lastFinancingDate",
    displayName: "Last financing date",
    cName: "detailmediumdata",
    type: "date",
  },
  {
    actualName: "numOfFundingRounds",
    displayName: "No. of funding round(s)",
    cName: "detailmldata",
    type: "quantity",
  },
  {
    actualName: "numOfInvestors",
    displayName: "No. of investors",
    cName: "detailmediumdata",
    type: "quantity",
  },
  {
    actualName: "investors",
    displayName: "Investors",
    cName: "detailmldata",
    type: "text",
  },
  {
    actualName: "revenue",
    displayName: "Total revenue",
    cName: "detailshortdata",
    type: "quantity",
  },
  {
    actualName: "market",
    displayName: "Market capitalization",
    cName: "detailmediumdata",
    type: "text",
  },
  {
    actualName: "investments",
    displayName: "No. of investments",
    cName: "detailshortdata",
    type: "quantity",
  },
  {
    actualName: "numOfAcquisitions",
    displayName: "No. of acquisitions",
    cName: "detailshortdata",
    type: "quantity",
  },
  {
    actualName: "boardSeats",
    displayName: "No. of board seats taken",
    cName: "detailmediumdata",
    type: "quantity",
  },
  {
    actualName: "competitors",
    displayName: "Competition",
    cName: "detailmldata",
    type: "text",
  },
  {
    actualName: "similarEntities",
    displayName: "Similar entities",
    cName: "detailmldata",
    type: "text",
  },
  {
    actualName: "management",
    displayName: "Management",
    cName: "detailmldata",
    type: "text",
  },
  {
    actualName: "numOfEmployees",
    displayName: "No. of employees",
    cName: "detailmediumdata",
    type: "quantity",
  },
  {
    actualName: "reputation",
    displayName: "Company reputation",
    type: "text",
  },
  {
    actualName: "phoneNumber",
    displayName: "Contact info",
    cName: "detailmediumdata",
    type: "text",
  },
  {
    actualName: "operationalDuration",
    displayName: "Operational duration",
    cName: "detailmldata",
    type: "quantity",
  },
  {
    actualName: "shutdownDate",
    displayName: "Shutdown date",
    cName: "detailmediumdata",
    type: "quantity",
  },
  {
    actualName: "foundedDate",
    displayName: "Founded date",
    cName: "detailmediumdata",
    type: "date",
  },
  {
    actualName: "legalName",
    displayName: "Legal name",
    cName: "detailmediumdata",
    type: "text",
  },
  {
    actualName: "former_legalName",
    displayName: "Former legal name(s)",
    cName: "detailmldata",
    type: "text",
  },
  {
    actualName: "ticker",
    displayName: "Ticker",
    cName: "detailshortdata",
    type: "text",
  },
  {
    actualName: "businessModelType",
    displayName: "Transactional model type",
    cName: "detailmldata",
    type: "text",
  },
  {
    actualName: "productReview",
    displayName: "Product review",
    cName: "detailshortdata",
    type: "text",
  },
  {
    actualName: "pitchdeck_show",
    displayName: "Data room",
    cName: "detailshortdata",
    type: "text",
  },
];
